import { useEffect, useState } from "react";
import { BUSINESS } from "../data/site";

const telHref = (p) => `tel:+1${String(p).replace(/\D/g, "").slice(-10)}`;

/**
 * Contact info that follows the CMS (Admin → Content tab → Business contact)
 * with the curated site.js values as an instant fallback.
 */
export default function useContactInfo() {
  const [info, setInfo] = useState(BUSINESS);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/content/contact`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (!d) return;
        const email = d.email || BUSINESS.email;
        setInfo({
          ...BUSINESS,
          phoneMain: d.phone_main || BUSINESS.phoneMain,
          phoneMainHref: d.phone_main ? telHref(d.phone_main) : BUSINESS.phoneMainHref,
          email,
          emailHref: `mailto:${email}`,
          serviceArea: d.service_area || BUSINESS.serviceArea,
        });
      })
      .catch(() => {});
  }, []);
  return info;
}
